import template from 'product-image-viewer.j2';

import { generate } from '../../../core/js/utils/componentUtils';
import { onStateChange } from '../utils/productComponentUtils';
import { mDom } from '../../../core/js/utils/renderUtils';
import { getSelectedSliceItem, getTargetedProduct } from '../utils/utils';
import { swiperInitialization } from '../utils/swiperInits';
import { createGAEvent } from '../../../core/js/utils/analyticsUtils';
import { handleUtagEvent } from '../../../core/js/actions/initialActions';

import { init as productZoomInit } from './productZoomComponent';

// the hax is strong with this one
// attach a listener to when the done button
// is click in the video player on PhoneOS safari,
// and force the video to re-load and show
// the poster once more
function attachSafariVideoEvents() {
    $('.js-product-video').on(
        'webkitendfullscreen',
        (e) => {
            e.preventDefault();
            e.currentTarget.load();
        }
    );
}

function attachSwiperAnalytics(swiper, store) {
    if (swiper) {
        swiper.on('onSlideChangeEnd', () => {
            const state = store.getState();
            const product = getTargetedProduct(state);

            if (product) {
                const productName = _.get(product, 'product.displayName', '');
                const gaEvent = createGAEvent(
                    'PAGE_TYPE',
                    'product image tile click',
                    `${productName} | tile ${swiper.activeIndex}`
                );

                store.dispatch(handleUtagEvent(gaEvent, 'link'));
            }
        });
    }
}

function getTargetSlideIndex(state) {
    let targetIndex = state.core.constants.carousel.video_index;

    if (_.isEmpty(targetIndex)) {
        const product = getTargetedProduct(state);

        const sliceItem = getSelectedSliceItem(
            product.skuInfo.primarySlice.sliceItems,
            product.skuInfo.primarySlice.sliceHashToIndex.code,
            product.productControls.colorCode
        );

        targetIndex = sliceItem.carouselCodes.length;
    }

    return targetIndex;
}

function reInitSwipers(store) {
    _.forOwn(this.swipers, (swiper, key) => {
        if (!_.isUndefined(swiper)) {
            swiper.destroy(false, true);
        }
    });

    this.swipers = this.swiperInitialization();

    const swiper = _.get(this.swipers, 'carousel');
    attachSwiperAnalytics(swiper, store);

    attachSafariVideoEvents();
}

function handleThumbnailsAnalytics(store, label) {
    const gaEvent = createGAEvent(
        'PAGE_TYPE',
        'product image arrow click',
        label
    );

    store.dispatch(handleUtagEvent(gaEvent, 'link'));
}

function attachEvents(store) {
    $(document).on(
        // no touch on this one, as the tap vs. swipe gestures
        // get confused on touchscreen devices
        this.scopedEvent('click'),
        this.scopedSelector('.js-product-video'),
        (e) => {
            e.currentTarget.play();
        }
    );

    $(document).on(
        this.scopedEvent('click'),
        this.scopedSelector('.js-carousel__play-video'),
        (e) => {
            e.preventDefault();
            const targetIndex = getTargetSlideIndex(store.getState());

            swiper.carousel.slideTo(targetIndex);
        }
    );

    $(document).on(
        this.scopedEvent('click'),
        this.scopedSelector('.js-slider-thumbnails__button--next'),
        () => {
            handleThumbnailsAnalytics(store, 'forward');
        }
    );

    $(document).on(
        this.scopedEvent('click'),
        this.scopedSelector('.js-slider-thumbnails__button--prev'),
        () => {
            handleThumbnailsAnalytics(store, 'back');
        }
    );
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .dom-product-image-viewer',
        watch: ['product.productImageViewer', 'core.deviceCharacteristics'],
        template: template,
        name: 'productImageViewerComponent',
        afterConstruction: reInitSwipers,
        afterRender: reInitSwipers,
        afterRebind: reInitSwipers,
        disableZoom: false,
        forFamilyProduct: false,
        onStateChange: onStateChange,
        renderType: mDom,
        attachEvents: attachEvents,
        swiperInitialization: swiperInitialization,
        children: [
            [productZoomInit, {
                relatedLocation: '.dom-pdp .dom-main-product .dom-product-image-viewer',
            }]
        ],
        rebind: true,
        swipers: {}
    };

    return generate(config, store, overrides);
}
